@if (title && codaltModusService.enabled()) {
    <div class="planning-history-section mt-4 mb-4">
        <h3>Planning - {{ title }}</h3>
        <div class="row mb-3 align-items-center">
            <div class="col-auto">
                <div class="btn-group">
                    @for (preset of presets; track preset.value) {
                        <button
                            class="btn btn-sm me-2"
                            [class.btn-primary]="activePreset() === preset.value"
                            [class.btn-outline-primary]="activePreset() !== preset.value"
                            (click)="setPreset(preset.value)">
                            {{ preset.label }}
                        </button>
                    }
                </div>
            </div>
            <div class="col-auto">
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Datum</mat-label>
                    <input
                        [matDatepicker]="datePicker"
                        [value]="selectedDate()"
                        (dateChange)="onDateSelected($event.value)"
                        matInput
                        placeholder="dd-mm-jjjj" />
                    <mat-datepicker-toggle [for]="datePicker" matIconSuffix></mat-datepicker-toggle>
                    <mat-datepicker #datePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        @if (loading()) {
            <div class="d-flex justify-content-center p-3">
                <div class="spinner-border" role="status">
                    <span>Laden...</span>
                </div>
            </div>
        } @else if (items()?.length) {
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead class="table-dark">
                        <tr>
                            <th scope="col">Datum</th>
                            <th scope="col">Tijd</th>
                            <th class="col-location" scope="col">Locatie</th>
                            @if (!projectId) {
                                <th scope="col">Project</th>
                            }
                            @if (!userId) {
                                <th scope="col">Gebruiker</th>
                            }
                            @if (!entityId) {
                                <th scope="col">Materieel</th>
                            }
                            <th class="col-location" scope="col">Opmerking</th>
                            <th scope="col">Verwijderd op</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of items(); track item.id) {
                            <tr
                                class="cursor-pointer"
                                [class.table-danger]="item.deleted_at"
                                (dblclick)="onPlanningClicked(item.planning_id)">
                                <td class="text-end">{{ item.begindate | date: 'EEE d MMM y' }}</td>
                                <td class="text-end text-nowrap">
                                    {{ item.begindate | date: 'HH:mm' }}
                                    @if (item?.enddate) {
                                        – {{ item?.enddate | date: 'HH:mm' }}
                                    }
                                </td>
                                <td class="col-location text-truncate">{{ item?.planning?.location ?? '-' }}</td>

                                @if (!projectId) {
                                    <td
                                        [style.cursor]="item.planning?.afas_project_id ? 'pointer' : 'default'"
                                        (click)="onProjectClicked(item.planning?.afas_project_id, $event)">
                                        {{ item?.planning?.project?.afas_project_id }} -
                                        {{ item?.planning?.project?.name ?? '-' }}
                                    </td>
                                }

                                @if (!userId) {
                                    <td>{{ item.user?.name ?? item.driver_user?.name }}</td>
                                }

                                @if (!entityId) {
                                    <td>{{ item.entity?.name ?? '-' }}</td>
                                }

                                <td class="col-location text-truncate">{{ item.comment ?? '-' }}</td>
                                <td class="text-end text-nowrap">
                                    @if (item.deleted_at) {
                                        {{ item.deleted_at | date: 'EEE d MMM y HH:mm' }}
                                    } @else {
                                        <span class="text-muted">-</span>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        } @else {
            <div class="alert alert-info" role="alert">Geen planningen gevonden</div>
        }
    </div>
}
